import React from 'react'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { Button, SvgIcon, Tooltip } from '@mui/material'
import { ReactComponent as TreeCodeLabelSvg } from '../../../assets/icons/tree-code-label.svg'
import BaseMapControl from './BaseMapControl'
import { getMapToggleButtonStyles } from './mapToggleButtonStyles'
import { toggleTreeCodeLabels } from '../../../redux/slices/Map/map'

const BUTTON_ARIA_LABEL = 'Códigos de árbol'
const TOOLTIP_SHOW_CODES = 'Mostrar códigos de árbol'
const TOOLTIP_HIDE_CODES = 'Ocultar códigos de árbol'

/**
 * Control para mostrar u ocultar los códigos de árbol sobre el mapa. Solo
 * cambia el estado en Redux (recordado durante la sesión); useTreeCodeLabels
 * aplica la visibilidad a la capa.
 */
class TreeCodeLabelsControl extends BaseMapControl {
  constructor(store, theme) {
    super({ className: 'tree-code-labels-control' })
    this.store = store
    this.theme = theme
  }

  _renderContent() {
    this._root?.render(
      <Provider store={this.store}>
        <TreeCodeLabelsButton theme={this.theme} />
      </Provider>,
    )
  }
}

// Definido a nivel de módulo para que update() no lo vuelva a montar.
const TreeCodeLabelsButton = ({ theme }) => {
  const dispatch = useDispatch()
  const treeCodeLabelsEnabled = useSelector(state => state.mapState.treeCodeLabelsEnabled)

  const handleToggle = () => {
    dispatch(toggleTreeCodeLabels())
  }

  const tooltipTitle = treeCodeLabelsEnabled ? TOOLTIP_HIDE_CODES : TOOLTIP_SHOW_CODES

  return (
    <Tooltip title={tooltipTitle} placement="left">
      <span>
        <Button
          onClick={handleToggle}
          size="small"
          aria-label={BUTTON_ARIA_LABEL}
          aria-pressed={treeCodeLabelsEnabled}
          sx={getMapToggleButtonStyles(theme, treeCodeLabelsEnabled)}>
          <SvgIcon component={TreeCodeLabelSvg} inheritViewBox fontSize="small" />
        </Button>
      </span>
    </Tooltip>
  )
}

export default TreeCodeLabelsControl
